<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="applyCategory"
						label="申请类别"
					>
					</el-table-column>
					<el-table-column
						prop="num"
						label="赠送/扣除次数"
					>
					</el-table-column>
					<el-table-column
						prop="productCategory"
						label="产品类别"
					>
					</el-table-column>
					<el-table-column
						prop="customerName"
						label="客户姓名"
					>
					</el-table-column>
					<el-table-column
						prop="customerMobile"
						label="客户手机号"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="status"
						label="状态"
					>
					</el-table-column>
					<el-table-column
						prop="reason"
						label="原因"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			excelId: {
				type: [String, Number],
				default: ''
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				tableData: []
			}
		},
		methods: {
			// 获取数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					rechargeExcelId: that.excelId
				};
				Api.getDetailByExcelId(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								applyCategory: '样品赠送',
								num: v.times,
								productCategory: v.productName,
								customerName: v.customerName,
								customerMobile: v.customerPhone,
								time: v.createTs.split(' ')[0],
								status: v.successFlag == 1 ? '成功' : (v.successFlag == 2 ? '失败' : ''),
								reason: v.errDesc || ''
							});
						});
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getList();
				} else {
					this.loading = false;
					this.tableData = [];
				}
			}
		}
	}
</script>

<style>
</style>
